// Unpublished Work © 2021-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {useDeepMemo} from 'Utils/react-utils';
import {MultiSelect} from '@deere/isg.component-library';

function SortedMultiSelect(props) {
    const {
        items,
        sortFunc,
        error,
        translations,
        ...otherProps
    } = props;

    const sortedItems = useDeepMemo(
        () => {
            if (sortFunc) {
                return sortFunc(items);
            }

            return items;
        }, [items, sortFunc]
    );

    return (
        <>
            <MultiSelect
                disableSorting={Boolean(sortFunc)}
                footerAction={props.footerAction}
                helperText={error}
                items={sortedItems}
                labels={{
                    multiSelect: props.multipleItemsSelectedLabel ?? '',
                    placeholder: props.defaultSelectLabel ?? '',
                    emptyList: translations.NO_ITEMS,
                    allSelect: props.allItemsLabel,
                    selectAllItems: translations.SELECT_ALL,
                    noItemMatch: translations.NO_RESULTS_FOUNDS
                }}
                single={!props.multiple}
                {...otherProps}
            />
        </>
    );
}

SortedMultiSelect.propTypes = {
    allItemsLabel: PropTypes.string,
    defaultSelectLabel: PropTypes.string,
    error: PropTypes.string,
    footerAction: PropTypes.object,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    multiple: PropTypes.bool,
    multipleItemsSelectedLabel: PropTypes.string,
    sortFunc: PropTypes.func,
    translations: PropTypes.translations
};

export default SortedMultiSelect;
